import { NewsListScreen } from '../features/news'

export function NewsListPage() {
  return <NewsListScreen />
}
